import React from 'react';
import { useTranslation } from 'react-i18next';

const H = ({ tag: Tag = 'p', html, className }) => (
  <Tag className={className} dangerouslySetInnerHTML={{ __html: html }} />
);
const LI = ({ html }) => <li dangerouslySetInnerHTML={{ __html: html }} />;

const CookiePolicy = () => {
  const { t } = useTranslation();

  const openPrefs = () => {
    if (typeof window.openCookiePreferences === 'function') {
      window.openCookiePreferences();
    }
  };

  return (
    <div className="legal-page">
      <div className="top-bar" />
      <div className="legal-container">
        <h1 className="legal-title">{t('cookiePolicy.title')}</h1>
        <p className="legal-update">{t('legal.lastUpdate')}: {t('legal.date')}</p>

        <section className="legal-section">
          <H html={t('cookiePolicy.intro')} />
        </section>

        <section className="legal-section">
          <h2>{t('cookiePolicy.s1t')}</h2>
          <H html={t('cookiePolicy.s1p')} />
        </section>

        <section className="legal-section">
          <h2>{t('cookiePolicy.s2t')}</h2>

          <h3>{t('cookiePolicy.s21t')}</h3>
          <H html={t('cookiePolicy.s21p')} />
          <ul>
            <LI html={t('cookiePolicy.s21l1')} />
            <LI html={t('cookiePolicy.s21l2')} />
          </ul>

          <h3>{t('cookiePolicy.s22t')}</h3>
          <H html={t('cookiePolicy.s22p')} />

          <h3>{t('cookiePolicy.s23t')}</h3>
          <H html={t('cookiePolicy.s23p')} />

          <h3>{t('cookiePolicy.s24t')}</h3>
          <H html={t('cookiePolicy.s24p')} />
        </section>

        <section className="legal-section">
          <h2>{t('cookiePolicy.s3t')}</h2>
          <H html={t('cookiePolicy.s3intro')} />
          <ul>
            <LI html={t('cookiePolicy.s3l1')} />
            <LI html={t('cookiePolicy.s3l2')} />
            <LI html={t('cookiePolicy.s3l3')} />
          </ul>
          <H html={t('cookiePolicy.s3p')} />
          <p>
            <button
              type="button"
              className="legal-pref-btn"
              onClick={openPrefs}
              data-testid="open-cookie-prefs-btn"
            >
              {t('cookiePolicy.s3btn')}
            </button>
          </p>
          <H html={t('cookiePolicy.s3browsers')} />
          <ul>
            <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
            <li><a href="https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
            <li><a href="https://support.apple.com/en-us/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Apple Safari</a></li>
            <li><a href="https://support.microsoft.com/en-us/microsoft-edge" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
          </ul>
          <H html={t('cookiePolicy.s3warn')} />
        </section>

        <section className="legal-section">
          <h2>{t('cookiePolicy.s4t')}</h2>
          <H html={t('cookiePolicy.s4p')} />
        </section>

        <section className="legal-section">
          <h2>{t('cookiePolicy.s5t')}</h2>
          <H html={t('cookiePolicy.s5p')} />
        </section>
      </div>
    </div>
  );
};

export default CookiePolicy;
